// extracted by mini-css-extract-plugin
export var box = "_9h-1";
export var checkboxRow = "_9h-8";
export var checked = "_9h-2";
export var descriptionSpacer = "_9h-a";
export var disabled = "_9h-3";
export var icon = "_9h-6";
export var input = "_9h-0";
export var labelSpacer = "_9h-9";
export var medium = "_9h-5";
export var small = "_9h-4";
export var text = "_9h-7";